// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10JAC","label":"styles_label__1qg4e"};